import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import moment from "moment";
import { asyncGetReport } from "../../../utils/httpRequests";
import {
  formatCurrencySmart,
  groupBy,
  numeralCustom,
} from "../../../utils/helpers";
import { Box, Stack, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import { sum } from "lodash";

function DoanhThuNhaHangTuanNay() {
  const theme = useTheme();
  const { token } = useSelector((state: any) => state.auth);
  const [chartData, setChartData] = useState<number[]>([]);

  const getReport = async () => {
    const today = moment();
    const resp = await asyncGetReport({
      apiCode: "ctbanle",
      token,
      query: {
        tu_ngay: today.clone().startOf("weeks").startOf("days").toISOString(),
        den_ngay: today.clone().endOf("weeks").endOf("days").toISOString(),
        ma_ct: "pbl_nh",
      },
    });
    if (resp && resp?.status === 200) {
      const data = resp?.data || [];
      data.pop();
      const groupedData = groupBy({
        data,
        callbackMatch: (item) => {
          return moment(item?.ngay_ct).format("DD/MM/YYYY");
        },
      }) as any[];
      const result = {
        T2: 0,
        T3: 0,
        T4: 0,
        T5: 0,
        T6: 0,
        T7: 0,
        CN: 0,
      };
      for (let i = 0; i < groupedData.length; i++) {
        const item = groupedData[i];
        const key: keyof typeof result = moment(item[0]?.ngay_ct).format(
          "dd"
        ) as keyof typeof result;
        const evenue = item.reduce(
          (acc: number, item: any) => acc + item.tien_nt,
          0
        );
        result[key] = evenue;
      }
      setChartData(Object.values(result));
    } else {
      setChartData([]);
    }
  };

  useEffect(() => {
    getReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        backgroundColor: "background.paper",
        borderRadius: "10px",
        px: 2,
        py: 2,
      }}
    >
      <Stack gap={1} sx={{ height: "100%" }}>
        <Typography sx={{ textAlign: "center", fontWeight: 600 }}>
          DOANH THU QUÁN ĂN TUẦN NÀY
        </Typography>
        <Box sx={{ flex: 1, "& > div": { width: "100%", height: "100%" } }}>
          <BarChart
            height={300}
            borderRadius={10}
            resolveSizeBeforeRender
            yAxis={[
              {
                valueFormatter: (val) => {
                  return formatCurrencySmart(val);
                },
              },
            ]}
            xAxis={[
              {
                scaleType: "band",
                data: ["T2", "T3", "T4", "T5", "T6", "T7", "CN"],
              },
            ]}
            series={[
              {
                type: "bar",
                color: theme.palette.primary.main,
                label: "Doanh thu",
                data: chartData,
              },
            ]}
          />
        </Box>
        <Typography sx={{ fontWeight: 600 }}>
          Tổng: {numeralCustom(sum(chartData)).format()}
        </Typography>
      </Stack>
    </Box>
  );
}

export default DoanhThuNhaHangTuanNay;
